'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _PropertyDetails = require('./PropertyDetails.scss');var styles = _interopRequireWildcard(_PropertyDetails);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PropertyGallery = function PropertyGallery(_ref) {var translate = _ref.translate,images = _ref.images,openLightbox = _ref.openLightbox,imagesLength = _ref.imagesLength;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.propertyGalleryWrapper, styles['gallery-' + images.length]) },
      images.map(function (item, index) {
        var handleClick = function handleClick() {return openLightbox(index);};
        var isLastImage = images.length === index + 1;

        return (
          _react2.default.createElement('div', {
              key: item.gallery,
              onClick: handleClick,
              className: (0, _classnames2.default)(styles.propertyGallery, {
                lastPropertyGallery: isLastImage }) },


            _react2.default.createElement('img', { src: item.gallery || item, alt: '' }),
            isLastImage && images.length > 1 &&
            _react2.default.createElement('div', { className: styles.seeAllWrapper },
              _react2.default.createElement('p', null, translate('propertyDetails', 'see') + ' ' + imagesLength + ' ' + translate('propertyDetails', 'gallery-photos')))));




      })));};



PropertyGallery.propTypes = {
  images: _propTypes2.default.array.isRequired,
  imagesLength: _propTypes2.default.number.isRequired,
  openLightbox: _propTypes2.default.func.isRequired,
  translate: _propTypes2.default.func.isRequired };exports.default =


PropertyGallery;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyDetails/PropertyGallery.js
// module id = 2853
// module chunks = 0